/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { submitUpdate } from "../../../actions/agencyProfileActions";
import Warning from "./Warning";
import {
  Wrapper,
  CloseButton,
  Form,
  Field,
  TextInput,
  Info,
  Buttons,
  SaveButton,
} from "./styles/company-specialities-edit-styles";

class CompanySpecialitiesEdit extends Component {
  constructor(props) {
    super(props);
    const { companySpecialities, userId } = this.props;

    this.state = {
      companySpecialities,
      userId,
      warningActive: false,
      focusedFieldId: null,
    };
  }

  toggleWarning = () => {
    this.setState(({ warningActive }) => ({ warningActive: !warningActive }));
  };

  handleChange = (e, id) => {
    const { companySpecialities } = this.state;
    const newSpecialities = [...companySpecialities];
    newSpecialities[id] = e.target.value;

    this.setState({
      companySpecialities: newSpecialities,
    });
  };

  setFocusedFieldId = (id) => {
    this.setState({
      focusedFieldId: id,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { submitUpdate, toggleEditSpecialities } = this.props;
    const { companySpecialities, userId } = this.state;

    submitUpdate(
      {
        userId,
        companySpecialities: [...new Set(companySpecialities.filter(Boolean))],
      },
      toggleEditSpecialities,
      "SPECIALITIES"
    );
  };

  render() {
    const { toggleEditSpecialities } = this.props;
    const { companySpecialities, warningActive, focusedFieldId } = this.state;

    return (
      <Wrapper>
        {warningActive && (
          <Warning
            toggleWarning={this.toggleWarning}
            closeForm={toggleEditSpecialities}
          />
        )}
        <CloseButton onClick={() => this.toggleWarning()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <Form>
          <Field>
            <TextInput
              maxLength={35}
              type="text"
              placeholder="Add a new speciality"
              value={companySpecialities[0] || ""}
              onChange={(e) => this.handleChange(e, 0)}
              onFocus={() => this.setFocusedFieldId(0)}
              onBlur={() => this.setState({ focusedFieldId: null })}
            />
            {focusedFieldId === 0 && <Info>Maximum of 35 characters</Info>}
          </Field>
          <Field>
            <TextInput
              maxLength={35}
              type="text"
              placeholder="Add a new speciality"
              value={companySpecialities[1] || ""}
              onChange={(e) => this.handleChange(e, 1)}
              onFocus={() => this.setFocusedFieldId(1)}
              onBlur={() => this.setState({ focusedFieldId: null })}
            />
            {focusedFieldId === 1 && <Info>Maximum of 35 characters</Info>}
          </Field>
          <Field>
            <TextInput
              maxLength={35}
              type="text"
              placeholder="Add a new speciality"
              value={companySpecialities[2] || ""}
              onChange={(e) => this.handleChange(e, 2)}
              onFocus={() => this.setFocusedFieldId(2)}
              onBlur={() => this.setState({ focusedFieldId: null })}
            />
            {focusedFieldId === 2 && <Info>Maximum of 35 characters</Info>}
          </Field>
          <Field>
            <TextInput
              maxLength={35}
              type="text"
              placeholder="Add a new speciality"
              value={companySpecialities[3] || ""}
              onChange={(e) => this.handleChange(e, 3)}
              onFocus={() => this.setFocusedFieldId(3)}
              onBlur={() => this.setState({ focusedFieldId: null })}
            />
            {focusedFieldId === 3 && <Info>Maximum of 35 characters</Info>}
          </Field>
          <Buttons>
            <SaveButton onClick={this.handleSubmit}>save</SaveButton>
          </Buttons>
        </Form>
      </Wrapper>
    );
  }
}

CompanySpecialitiesEdit.propTypes = {
  toggleEditSpecialities: PropTypes.func.isRequired,
  submitUpdate: PropTypes.func.isRequired,
  companySpecialities: PropTypes.arrayOf(PropTypes.string).isRequired,
  userId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  companySpecialities: state.agencyProfile.profileData.companySpecialities,
  userId: state.agencyProfile.profileData.user.id,
});

export default connect(mapStateToProps, { submitUpdate })(
  CompanySpecialitiesEdit
);
